module.exports = __webpack_public_path__ + "img/1-07.1e05bd04.jpg";